import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { dsar } from "../src/landingPage/datasets/forms/dsar";
import { meta } from "../src/landingPage/datasets/meta";
import { DataFormTemplate } from "../src/landingPage/views/Forms/templates/DataFormTemplate";
import { WorkInProgress } from "../src/platform/components/WorkInProgress/WorkInProgress";

const DsarPage = () => {
  const notice =
    "Our Data Subject Action form is currently experiencing a temporary disruption due to unusually high and potentially malicious traffic.";

  return (
    <WorkInProgress enabled={false} notice={notice}>
      <NextHead
        currentPath="/data-subject-action-request"
        title={meta.dsar.title}
        description={meta.dsar.description}
      />
      <DataFormTemplate type="DSAR" data={dsar} />
    </WorkInProgress>
  );
};

export const getInitialProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default DsarPage;
